<div class="modal active exportModal">
  <div class="modal__container modal__container--md">
      <div class="fields">
          <h2>Export {{ entity }}</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
          <label class="exportModal__desc">Choose the file type for your export:</label>
          <div class="fields__container">
            <div class="fields__container__button" *ngFor="let option of this.optionsToDisplay">
              <div (click)="this.exportFile(option)">
                <label>{{ option }}</label>
              </div>
            </div>
          </div>
      </div>
  </div>
</div>

